import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, styled } from "@mui/material";

const MobileStyledLogo = styled("img")(({ theme }) => ({
  marginRight: theme.spacing(4),
  width: "60px",
  height: "27px",
}));

type MobileMenuButtonProps = {
  onClick: () => void;
};

const MenuButtonPositioner = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: theme.spacing(3),
  right: theme.spacing(5),
}));

const CircularMenuButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

export const MobileMenuButton = ({ onClick }: MobileMenuButtonProps) => (
  <>
    <MobileStyledLogo src={"ISSVR_Logo.png"} alt="logo" />
    <MenuButtonPositioner>
      <CircularMenuButton onClick={onClick}>
        <MenuIcon />
      </CircularMenuButton>
    </MenuButtonPositioner>
  </>
);
